import React from 'react';
import { UserCheckIcon, ClockIcon, ShieldCheckIcon } from 'lucide-react';
export function KeyHighlights() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3059">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3060">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-3061">
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3062">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-3063">
              <UserCheckIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-3064" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-3065">
              Ages 21+
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3066">
              Must have experience and familiarity with both handguns and long
              guns.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3067">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-3068">
              <ClockIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-3069" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-3070">
              9-Hour Course
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3071">
              Approximately 9 hours with only a 1/2 hour lunch break. Bring
              lunch, snacks, and drinks.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3072">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-3073">
              <ShieldCheckIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-3074" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-3075">
              NRA Certification
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3076">
              Earn your NRA Range Safety Officer certification upon passing the
              exam.
            </p>
          </div>
        </div>
      </div>
    </div>;
}